import React, { Component } from 'react';
import { journaliserException } from '../../App_Code/API';
import logo from '../../Img/Gmc_Blanc.svg';

class PageException extends Component {
    state = {
        Erreur: false,
    };

    componentDidCatch(error, info) {
        const Chemin = window.location.pathname.split('/');

        if (process.env.NODE_ENV !== 'development') {
            const Methode = info.componentStack
                .replace('    ', '')
                .split('\n', 2)[1]
                .split(' ', 2)[1];

            const EE = {
                Page: Chemin[Chemin.length - 1],
                Methode,
                Message: `Exception fatale : ${error.message}`,
                Source: window.location.href,
                PileComposant: info.componentStack.slice(1).replace(/(?:\r\n|\r|\n)/g, '<br>'),
                PileErreur: error.stack,
            };

            journaliserException(EE);
        }

        document.body.classList.remove('fixed-nav');
        this.setState({ Erreur: true });
    }

    quitterPage = () => {
        document.body.classList.add('fixed-nav');
        this.setState({ Erreur: false });
    };

    render() {
        if (!this.state.Erreur) {
            return this.props.children;
        }

        return (
            <div className="y100 center full-bg">
                <img className="logo mb-3" src={logo} alt="Gérer ma copro" />
                <p className="texte text-light">
                    Oups ! Une exception vient de se produire...
                    <br />
                    Notre équipe va corriger ce problème dans les plus brefs délais.
                    <br />
                    Veuillez nous excuser pour la gêne occasionnée.
                </p>
                <p className="texte">
                    <a href="/" className="btn btn-lg btn-primary" onClick={() => this.quitterPage()}>
                        Retourner sur la page d&apos;accueil
                    </a>
                </p>
            </div>
        );
    }
}
PageException.displayName = 'PageException';

export default PageException;



// WEBPACK FOOTER //
// ./src/components/App/PageException.js